// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__gPW3M","iosIntro":"Loader_iosIntro__QGkp+","pulse":"Loader_pulse__BwInK"};